import { ListingStatus, ListingStatusCerberus } from '@hcs/types';

const LISTING_STATUS_PG_TO_CERBERUS: {
  [key in ListingStatus]: ListingStatusCerberus;
} = {
  SOLD: ListingStatusCerberus.Closed,
  PENDING: ListingStatusCerberus.Pending,
  LEASED: ListingStatusCerberus.Closed,
  UNKNOWN: ListingStatusCerberus.Closed,
  CONTINGENT: ListingStatusCerberus.ActiveUnderContract,
  ACTIVE: ListingStatusCerberus.Active,
  CLOSED: ListingStatusCerberus.Closed,
  WITHDRAWN: ListingStatusCerberus.Withdrawn,
  DELETED: ListingStatusCerberus.Delete,
  COMING_SOON: ListingStatusCerberus.ComingSoon,
  CANCELLED: ListingStatusCerberus.Canceled,
  EXPIRED: ListingStatusCerberus.Expired,
};

// Only used by AEXP until the switch to cerberus
export const listingStatusPgToCerberus = (
  listingStatusPg: ListingStatus | null | undefined,
): ListingStatusCerberus | null | undefined =>
  listingStatusPg && LISTING_STATUS_PG_TO_CERBERUS[listingStatusPg];
